"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearerAuthenticationProvider = exports.NetworkClientNoopAuthenticationProvider = void 0;
/**
 * Pass through authentication provider
 *
 * Useful for tests
 */
class NetworkClientNoopAuthenticationProvider {
    async getRequestHeaders() {
        // Do nothing
        return {};
    }
}
exports.NetworkClientNoopAuthenticationProvider = NetworkClientNoopAuthenticationProvider;
class BearerAuthenticationProvider {
    constructor(bearerToken) {
        this.bearerToken = bearerToken;
        // Do nothing
    }
    async getRequestHeaders() {
        // Do nothing
        return {
            authorization: `Bearer ${this.bearerToken}`,
        };
    }
}
exports.BearerAuthenticationProvider = BearerAuthenticationProvider;
